import { ImageOptionalLink } from '@rsa-digital/evo-shared-components/commonTypes/links';
// eslint-disable-next-line import/no-named-as-default
import { DoubleHeader } from '@rsa-digital/evo-shared-components/components/Header';
import React from 'react';
import { useHeaderData } from './useHeaderData';

const Header: React.FC<{
  toggleMenuCallback?: (open: boolean) => void;
  minimalHeader?: boolean;
  locale: string;
}> = ({ toggleMenuCallback, minimalHeader, locale }) => {
  const headerData = useHeaderData(locale);

  const logoLink: ImageOptionalLink = {
    image: headerData.logoLink.image,
    link: minimalHeader ? undefined : headerData.logoLink.link,
  };

  return (
    <DoubleHeader
      id="header"
      defaultLogoLink={logoLink}
      desktopLogoLink={logoLink}
      phoneIconLink={headerData?.phoneIconLink}
      primaryNav={minimalHeader ? undefined : headerData.primaryNav}
      tertiaryNavItems={headerData.tertiaryNavItems}
      languageToggle={headerData.languageToggle}
      toggleMenuCallback={toggleMenuCallback}
      forceHamburgerMenuIcon
      showTertiaryIconsMobile
      usePrimaryNavFourColumnLayout
      showArrowsOnPrimaryNav
      showMobilePhoneIcon
      enableKeyboardNavigation
      data-cy="Header"
    />
  );
};

export default Header;
